export const en_43 = { 
    "common": {
        "pay": "PROCEED",
    },
    "send_balance": {
        "store_pin_payment_msg" :"Please click \"PROCEED\" below to complete the transaction. Once transaction is completed, an email will be sent to you with the receipt.",
        "reward_code_applied": "PIN Applied",
        'promo_code_discount_label': 'PIN Discount',
    }
}